export default "__VITE_ASSET__T0JvpkBy__"